import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "wrapper", "content", "closeButton"]
  static values = {
    currentUserId: Number,
    bookingId: Number
  }

  connect() {
    console.log("MemberBookingActions controller connected")
  }

  showDetails(event) {
    event.preventDefault()
    const bookingId = event.currentTarget.dataset.bookingId
    this.bookingIdValue = bookingId

    // Afficher la modal
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.wrapperTarget.classList.remove("scale-95", "opacity-0")
    this.wrapperTarget.classList.add("scale-100", "opacity-100")

    // Charger les détails de la réservation
    fetch(`/reservations/${bookingId}/member_booking_details`)
      .then(response => response.text())
      .then(html => {
        this.contentTarget.innerHTML = html
      })
  }

  closeDialog() {
    this.wrapperTarget.classList.remove("scale-100", "opacity-100")
    this.wrapperTarget.classList.add("scale-95", "opacity-0")
    
    setTimeout(() => {
      this.modalTarget.classList.remove("flex")
      this.modalTarget.classList.add("hidden")
      this.contentTarget.innerHTML = ""
    }, 300)
  }

  confirmBooking() {
    const bookingId = this.bookingIdValue
    fetch(`/reservations/${bookingId}/confirm`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'success') {
        // Mettre à jour l'état dans la liste
        const bookingRow = document.querySelector(`[data-booking-id="${bookingId}"]`)
        if (bookingRow) {
          const stateBadge = bookingRow.querySelector('.status-badge')
          if (stateBadge) {
            stateBadge.textContent = '✅ Confirmée'
            stateBadge.className = `status-badge bg-green-100 text-green-800 px-2 inline-flex text-xs leading-5 font-semibold rounded-full`
          }
        }
        
        // Afficher le message de confirmation dans la popup
        this.contentTarget.innerHTML = `
          <div class="p-8">
            <div class="flex items-center justify-center mb-6">
              <div class="text-green-500 text-6xl">✅</div>
            </div>
            <div class="space-y-4">
              <h3 class="text-2xl font-bold text-center">Suivi de réservation mis à jour</h3>
              <p class="text-lg text-gray-700 text-center">
                Le statut de la réservation a été marqué comme "confirmée" dans votre espace de suivi.
              </p>
              <div class="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <p class="text-yellow-800 text-center">
                  ⚠️ Important : Cette action ne communique pas avec l'hébergement.<br>
                  C'est uniquement un outil de suivi interne pour votre organisation.
                </p>
              </div>
            </div>
            <div class="mt-8 text-center">
              <button 
                class="bg-blue text-yellow hover:bg-yellow hover:text-blue px-6 py-3 rounded-lg text-lg font-medium"
                data-action="member-booking-actions#closeDialog">
                Fermer
              </button>
            </div>
          </div>
        `
      } else {
        alert(data.message)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Une erreur est survenue lors de la confirmation de la réservation')
    })
  }

  cancelBooking() {
    const bookingId = this.bookingIdValue
    fetch(`/reservations/${bookingId}/cancel`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'success') {
        // Mettre à jour l'état dans la liste
        const bookingRow = document.querySelector(`[data-booking-id="${bookingId}"]`)
        if (bookingRow) {
          const stateBadge = bookingRow.querySelector('.status-badge')
          if (stateBadge) {
            stateBadge.textContent = '❌ Annulée'
            stateBadge.className = `status-badge bg-red-100 text-red-800 px-2 inline-flex text-xs leading-5 font-semibold rounded-full`
          }
        }
        
        // Afficher le message de confirmation dans la popup
        this.contentTarget.innerHTML = `
          <div class="p-8">
            <div class="flex items-center justify-center mb-6">
              <div class="text-red-500 text-6xl">❌</div>
            </div>
            <div class="space-y-4">
              <h3 class="text-2xl font-bold text-center">Suivi de réservation mis à jour</h3>
              <p class="text-lg text-gray-700 text-center">
                Le statut de la réservation a été marqué comme "annulée" dans votre espace de suivi.
              </p>
              <div class="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
                <p class="text-yellow-800 text-center">
                  ⚠️ Important : Cette action ne communique pas avec l'hébergement.<br>
                  C'est uniquement un outil de suivi interne pour votre organisation.
                </p>
              </div>
            </div>
            <div class="mt-8 text-center">
              <button 
                class="bg-blue text-yellow hover:bg-yellow hover:text-blue px-6 py-3 rounded-lg text-lg font-medium"
                data-action="member-booking-actions#closeDialog">
                Fermer
              </button>
            </div>
          </div>
        `
      } else {
        alert(data.message)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('Une erreur est survenue lors de l\'annulation de la réservation')
    })
  }
} 